import script from "./EnhancedOrderSubmitButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnhancedOrderSubmitButton.vue?vue&type=script&setup=true&lang=ts"

import "./EnhancedOrderSubmitButton.vue?vue&type=style&index=0&id=392fcf52&scoped=true&lang=css"

import exportComponent from "../../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-392fcf52"]])

export default __exports__